<ng-container *transloco="let t">
  <article
    class="file-card"
    [class.file-card-upload-failed]="status === 'UPLOAD_FAILED'"
    [class.file-card-validation-resolvable]="status === 'VALIDATION_RESOLVABLE'"
    [class.file-card-validation-permanent]="status === 'VALIDATION_PERMANENT'">
    <div class="file-icon" aria-hidden="true">
      <mzic-svg [src]="getFileIcon(fileName)" />
    </div>

    <div class="file-content">
      <p class="file-name">{{ fileName }}</p>
      @if (sizeBytes !== null) {
        <p class="file-size">{{ formatFileSize(sizeBytes) }}</p>
      }
      @if (statusLabel) {
        <p class="file-status-label">{{ statusLabel }}</p>
      }
      @if (statusDetail) {
        <p class="file-status-detail">{{ statusDetail }}</p>
      }
    </div>

    <div class="file-action">
      @if (status === 'UPLOADING') {
        <span
          class="upload-spinner"
          role="status"
          [attr.aria-label]="t('lang.file_upload_uploading_named', { name: fileName })">
          <mzic-spinner />
        </span>
      } @else if (action === 'RETRY') {
        <button
          class="retry-button"
          type="button"
          [disabled]="actionDisabled"
          [attr.aria-label]="t('lang.file_upload_retry_named', { name: fileName })"
          [mzicTooltip]="t('lang.file_upload_retry_tooltip')"
          (click)="retryUpload.emit()">
          <mzic-svg src="assets/icons/refresh.svg" />
        </button>
      } @else if (action === 'REMOVE') {
        <button
          class="remove-button"
          type="button"
          [disabled]="actionDisabled"
          [attr.aria-label]="t('lang.file_upload_remove_named', { name: fileName })"
          (click)="removeFile.emit()">
          <mzic-svg src="assets/icons/mzic-trash.svg" />
        </button>
      }
    </div>
  </article>
</ng-container>
